import { Avatar } from '@mui/material';
import type { AuthUser } from '../model/types';

interface UserAvatarProps {
  user: Pick<AuthUser, 'email' | 'displayName' | 'avatarUrl'>;
  size?: number;
}

/**
 * Who this is, as a picture or as a letter.
 *
 * The initial is the fallback rather than a grey silhouette: most accounts will never set a
 * picture, and "M" still identifies Maria to the person looking at their own header. A
 * silhouette says only that something is missing.
 */
export function UserAvatar({ user, size = 32 }: UserAvatarProps) {
  const initial = (user.displayName ?? user.email ?? '?').charAt(0).toUpperCase();

  return (
    <Avatar
      src={user.avatarUrl ?? undefined}
      // Empty on purpose: the name is already beside it everywhere this appears, and a
      // screen reader reading it twice is noise. When the picture fails to load, MUI falls
      // back to the children below rather than to this text.
      alt=""
      sx={{ width: size, height: size, bgcolor: 'primary.main', fontSize: size * 0.44 }}
    >
      {initial}
    </Avatar>
  );
}
